/**
 * The schedule dialog loads on first open: it pulls in the staff / member
 * pickers' APIs, which the conversation itself does not need.
 */

import { lazy } from 'react';

export const LazyScheduleMeetingDialog = lazy(() =>
  import('./ScheduleMeetingDialog').then((m) => ({ default: m.ScheduleMeetingDialog })),
);
